import $ from "jquery";
import setAppLinksParams from "scripts/components/setAppLinksParams";
import addGlobalEvent from "scripts/utils/addGlobalEvent";
import header from "../components/header";
import response from "../components/response";
import forms from "../components/forms";
import modals from "../components/modals";
import { initLandingForm } from "../components/landing";
import Select from "../components/select";
import { GAPageView } from "scripts/components/ga/page_view";
import { initSupport, openHelpCrunchChat } from "scripts/components/support/support";
import {initLazyLoadingRecaptcha} from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  GAPageView();
  addGlobalEvent(document, 'click', '.js_activated_toggle', function activateToggleBlock() {
    if (!this) return;
    this.closest(".js_activated_block").classList.toggle('active');
  });
  addGlobalEvent(document, 'click', '.js_open_chat', function openChat() {
    openHelpCrunchChat();
  });
  header();
  response();
  forms();
  modals();
  initLandingForm();
  window.customSelect = new Select();

  setAppLinksParams();
  initSupport();
  initLazyLoadingRecaptcha();
});